import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Warehouse from "./Warehouse";
import GridConfig from "./GridConfig";

export default class Warehouses extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'warehouse',
            data: null,
            loading: true,
            configName: 'warehouses_grid',
            moduleName: 'انبارها'
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Warehouse Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Warehouse Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "نام انبار", show: true },
                { field: "code", caption: "کد", show: true },
                { field: "address", caption: "آدرس", show: true },
                { field: "phone", caption: "تلفن", show: true },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.number}</a> } });
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'address' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'phone' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "85%" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="mr-10">
                            <div className="center-block">
                                {this.getToolBar(false)}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}